import { useState } from "react";

import { LazyLoadImage } from 'react-lazy-load-image-component';

export const LazyLoadImageCDN = ({ cdnPath, localPath, alt, libAssetsPath=window.ROBOT_LIB_ASSETS, classname="", id="", width="", max_width="", height="" }) => {
    const [imgSrc, setImgSrc] = useState(cdnPath);
    const [attempts, setAttempts] = useState(0);

    return (
        <LazyLoadImage
            className={classname ? classname : undefined}
            id={id ? id : undefined}
            src={imgSrc}
            alt={alt}
            width={width ? width : undefined}
            style={{ maxWidth: max_width ? max_width : undefined }}
            height={height ? height : undefined}
            onError={() => {
                const nextAttempt = attempts + 1;
                setAttempts(nextAttempt);

                //if (nextAttempt === 1)
                //    setImgSrc(localPath);
                //else
                setImgSrc(libAssetsPath + "np-icon.png");
            }}
            threshold={100}
        />
    );
};
